module.exports = (function () {
  if (typeof window.hubspot === 'undefined') {
    throw new Error('Could not find hubspot global variable.');
  }
  return window.hubspot;
}());